<section class="main-wrap inner-views dashboard-wrap" [ngClass]="{ 'menu-open in': !toggleClass }">
  <nav class="navbar navbar-expand-lg" id="desk-top-nav">
    <app-user-menu></app-user-menu>
    <div class="button-box">
      <button class="btn dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
        <span class="sr-only">Toggle Dropdown</span>
        <img height="45" src="assets/images/icons/hamburger-menu-50x50.svg" width="45" alt="Menu Icon">
      </button>
      <div class="dropdown-menu">
        <app-menu></app-menu>
        <app-menu-alt></app-menu-alt>
      </div>
    </div>
  </nav>
  <div class="container-wrap">
    <div class="heading-container sidebar-container" id="menu">
      <div class="row">
        <div class="col">
          <app-logo></app-logo>
          <div class="button-box">
            <button class="btn btn-sm-menu" type="button" (click)="toggleClass = !toggleClass">
              <img height="45" src="assets/images/icons/hamburger-menu-50x50.svg" width="45" alt="Menu Icon">
            </button>
          </div>
          <app-header></app-header>
        </div>
      </div>
    </div>
    @if (cartItemsTotal) {
      <div class="content-container products-container product-favorites product-cart">
        <div class="row">
          <div class="clearfix"></div>
          <div class="col-md-8">
            <div class="col-md-12 cart-title">
              <h1><span><span class="items-no">{{cartItemsTotal.cartItems.length}}</span> items in Cart</span></h1>
            </div>
            <div class="clearfix"></div>
            @if (cartItemsTotal.cartItems.length > 0) {
              @for (cartItem of cartItemsTotal.cartItems; track $index; let i = $index) {
                @if ((cartItem.itemCategory.includes(orderCategories.glasses))) {
                  <div>
                    <app-glasses-cart-item-details [glassesItem]="cartItem"
                      [prescriptionStatus]="prescriptionStatusText"
                      (removeCartItemEvent)="removeCartItem($event)">
                    </app-glasses-cart-item-details>
                  </div>
                }
                @if (cartItem.itemCategory == orderCategories.respiratorInserts) {
                  <div>
                    <app-respirator-inserts-cart-item-details [respiratorItem]="cartItem"
                      [prescriptionStatus]="prescriptionStatusText"
                      (removeCartItemEvent)="removeCartItem($event)">
                    </app-respirator-inserts-cart-item-details>
                  </div>
                }
                @if (cartItem.itemCategory == orderCategories.shoes) {
                  <div>
                    <app-shoes-cart-item-details [shoeItem]="cartItem"
                      (removeCartItemEvent)="removeCartItem($event)">
                    </app-shoes-cart-item-details >
                  </div>
                }
              }
            }
            <div class="clearfix"></div>
            <div class="row inner-row">
              <div class="col-md-12 cart-title">
                <h2>Other Benefits Available</h2>
              </div>
              <div class="clearfix"></div>
              <app-modules-container
                [colClass]="'col-md-4'"
                [isCartView]="true"
                [modules]="modules">
              </app-modules-container>
            </div>
          </div>
          <div class="col-md-4">
            <div class="cart-shop-box">
              <p><strong>Subtotal:</strong> <span class="subtotal">{{cartItemsTotal.subtotal | currency}}</span></p>
              <p><strong>Benefit Covers:</strong> <span class="subtotal">{{cartItemsTotal.benefitAmount | currency}}</span></p>
            </div>
            <div class="cart-shop-balance">
              <h3>Your Balance: <span class="cart-balance">{{cartItemsTotal.total | currency}}</span></h3>
              <div class="cart-action">
                @if (canCheckout) {
                  <button [routerLink]="'/checkout'" class="btn product-btn go-to-checkout gray-btn" type="button">Proceed to Checkout</button>
                }
                <button [routerLink]="'/dashboard'" class="btn product-btn go-to-shop white-btn" type="button">Continue Shopping</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    }
  </div>
</section>
